// extracted by mini-css-extract-plugin
module.exports = {"root":"EsmsModal_root__EMeSC","header":"EsmsModal_header__1MoKS","body":"EsmsModal_body__KKXhS","content":"EsmsModal_content__1sbyl","figure":"EsmsModal_figure__3NmPu"};